let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5hkA9")).then(() => parcelRequire('gg4u8'));